import { render, staticRenderFns } from "./CompetitionFilterMyLayout.vue?vue&type=template&id=2bbd8e46&scoped=true&"
import script from "./CompetitionFilterMyLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterMyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd8e46",
  null
  
)

export default component.exports